import React from 'react';
import { BookMarked, Check } from 'lucide-react';

const FEATURES = [
  'Full library of pre-packaged sermon series',
  'Graphics, social media art, slides & outlines',
  'Import complete series into your library',
  'Up to 2 series imports per month',
  'New series added regularly',
];

export function SeriesUpgradeGate() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4 py-12 text-center">
      <div className="w-16 h-16 rounded-2xl bg-electric/10 flex items-center justify-center mb-6">
        <BookMarked className="h-8 w-8 text-electric" />
      </div>

      <div className="inline-flex items-center gap-1.5 px-3 py-1 bg-electric/10 text-electric text-xs font-semibold rounded-full mb-4 uppercase tracking-wide">
        Coming Soon
      </div>

      <h1 className="text-2xl font-bold text-midnight dark:text-soft-white mb-2">
        Sermon Series Library
      </h1>
      <p className="text-slate dark:text-soft-white/60 max-w-md mb-8">
        Pre-packaged sermon series with everything you need — notes, graphics, slides, and social art — ready to import into your library.
      </p>

      <ul className="space-y-2 mb-8 text-left max-w-sm w-full">
        {FEATURES.map(f => (
          <li key={f} className="flex items-center gap-2.5">
            <Check className="h-4 w-4 text-electric shrink-0" />
            <span className="text-sm text-midnight dark:text-soft-white">{f}</span>
          </li>
        ))}
      </ul>

      <button
        disabled
        className="px-8 py-3 bg-slate/20 text-slate dark:text-soft-white/40 font-medium rounded-xl cursor-not-allowed"
      >
        Coming Soon
      </button>

      <p className="text-xs text-slate dark:text-soft-white/40 mt-3">
        We'll notify you when this launches.
      </p>
    </div>
  );
}
